interface ITableSorting {
    sortRows: (data: object[], field: string, sortState: string) => void;
}

abstract class ITableSort implements ITableSorting {
    public abstract sortRows(data: object[], field: string, sortState: string);
}

export { ITableSort };
